import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */

import SvgIcon from '@mui/material/SvgIcon';
import ArrowIconSrc from './icons/ArrowIconSrc.component.svg';
import markerIconSize from './constants/markerIconSize';
const BulletPointArrowIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SvgIcon component={ArrowIconSrc} width={markerIconSize} height={markerIconSize} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BulletPointArrowIcon;